module.exports = __webpack_public_path__ + "static/media/arrow-up.55e199d4.svg";